import React, { useEffect, useState } from 'react';
import StyledTable from "../../../commons/styles/table";

const TableSelect = ({ data: propsData, columns, handleDropdownChange }) => {
  const [data, setData] = useState(propsData || []);

  useEffect(() => {
    setData(propsData);
  }, [propsData]);

  // const setTranslation = (keyword) => {
  //   return translationCache && translationCache[keyword] ? translationCache[keyword] : keyword;
  // };

  return (
    <div style={{ height: '70%', marginTop: '10px' }}>
      <StyledTable size="small"
        columns={columns}
        dataSource={data}
        onRow={(record) => ({
          onClick: () => {
            handleDropdownChange(record);
          }
        })}
      />
    </div>
  );
};

export default TableSelect;